export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              关于我们
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              萝卜影视 — 专注电视剧全集与连续剧完整版在线观看
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            <div className="flex-1 space-y-5">
              <div>
                <h3 className="font-heading text-xl text-foreground-100 mb-3">
                  我们的使命
                </h3>
                <p className="text-foreground-400 text-sm leading-relaxed">
                  萝卜影视致力于为广大追剧爱好者打造一站式电视剧在线全集观看平台。我们深知等待更新的煎熬，因此专注于收录电视剧全集、连续剧完整版与电视剧大结局，让每一位剧迷都能一次性看完整部剧，告别"追更"的焦虑。
                </p>
              </div>
              <div>
                <h3 className="font-heading text-xl text-foreground-100 mb-3">
                  内容覆盖
                </h3>
                <p className="text-foreground-400 text-sm leading-relaxed">
                  平台已收录超过2000部电视剧全集，涵盖国产剧、韩剧、美剧、日剧、港剧等热门类型。无论是口碑神作还是最新热播，萝卜影视都力争第一时间上线完整版资源。所有剧集均支持高清播放，流畅不缓冲，让追剧体验更纯粹。
                </p>
              </div>
              <div>
                <h3 className="font-heading text-xl text-foreground-100 mb-3">
                  核心理念
                </h3>
                <p className="text-foreground-400 text-sm leading-relaxed">
                  免费、高清、全集 — 这是萝卜影视始终坚守的三个原则。我们相信好剧值得被更多人看到，因此不设门槛，无需注册即可畅享所有内容。每日同步更新最新资源，确保电视剧大结局第一时间上线，让您的追剧之旅不留遗憾。
                </p>
              </div>
            </div>

            <div className="flex-shrink-0 w-full max-w-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20home%20theater%20setup%20with%20a%20large%20screen%20showing%20cinematic%20content%2C%20comfortable%20sofa%20with%20blanket%2C%20dim%20ambient%20lighting%20in%20warm%20tones%2C%20popcorn%20bowl%20on%20coffee%20table%2C%20modern%20living%20room%20aesthetic%2C%20inviting%20atmosphere%2C%20no%20text&width=500&height=500&seq=about-luobo-01&orientation=squarish"
                alt="萝卜影视平台介绍"
                className="w-full h-auto rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}